const isTest = process.env.SERVER_ENV === 'test';
const compVersion = isTest ? 'dev' : 'v';
export const hostConfigs = [
  {
    hosts: [
      'local.qq.com:8080',
      'lbs.cs0309.3g.qq.com',
      'openlbs.sparta.html5.qq.com',
      'lbs_test_doc.sparta.html5.qq.com',
      'lbs-test-doc.testsite.woa.com',
      'lbs.qq.com',
    ],
    doc: {
      script: [
        {
          name: 'header',
          src: `https://mapapi.qq.com/web/lbsComponents/${compVersion}/lbs-header.js?v=4`,
        },
        {
          name: 'footer',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-footer.js',
        },
        {
          name: 'statistic',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-statistic.js',
        },
      ],
      callback: `
        window.TLBSHeader.init({
          container: document.getElementById('lbs-header'),
          theme: 'light',
          position: 'sticky',
          zIndex: 9999,
          activeMenu: 3,
          background: true
        });
        window.TLBSFooter.init({
          container: document.getElementById('lbs-footer'),
          theme: 'light',
        });
      `,
    },
    sdkDemo: {
      script: [
        {
          name: 'header',
          src: `https://mapapi.qq.com/web/lbsComponents/${compVersion}/lbs-header.js`,
        },
        {
          name: 'statistic',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-statistic.js',
        },
      ],
      callback: `
        window.TLBSHeader.init({
          container: document.getElementById('lbs-header'),
          theme: 'light',
          position: 'sticky',
          zIndex: 9999,
          activeMenu: 3,
          background: true
        });
      `,
    },
    demo: {
      script: [
        {
          name: 'header',
          src: `https://mapapi.qq.com/web/lbsComponents/${compVersion}/lbs-header.js`,
        },
        {
          name: 'statistic',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-statistic.js',
        },
      ],
      callback: `
        window.TLBSHeader.init({
          container: document.getElementById('lbs-header'),
          theme: 'dark',
          zIndex: 9999,
          background: true
        });
      `,
    },
    news: {
      script: [
        {
          name: 'header',
          src: `https://mapapi.qq.com/web/lbsComponents/${compVersion}/lbs-header.js`,
        },
        {
          name: 'footer',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-footer.js',
        },
        {
          name: 'statistic',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-statistic.js',
        },
      ],
      callback: `
        window.TLBSHeader.init({
          container: document.getElementById('lbs-header'),
          position: 'sticky',
          theme: 'dark',
          zIndex: 9999,
        });
        window.TLBSFooter.init({
          container: document.getElementById('lbs-footer')
        });
      `,
    },
    showFeedback: true,
    appkey: '0WEB0WM5U946MCJ3', // 灯塔appkey
  },
  {
    hosts: ['wemaptest.map.qq.com', 'wemappre.map.qq.com', 'wemap.qq.com'],
    doc: {
      script: [
        {
          name: 'header',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/wemap/wemap-header.js',
        },
        {
          name: 'statistic',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-statistic.js',
        },
        {
          name: 'footer',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-footer.js',
        },
      ],
      callback: `
        document.getElementById('lbs-header').style.height = '72px';
        // document.getElementById('sidebar-wrapper').style.top = '72px';
        const header = window.TWeMapHeader.init({
          container: document.getElementById('lbs-header'),
          theme: 'light',
          position: 'fixed',
        });
        header.setActiveMenu('服务与支持');
        window.TLBSFooter.init({
          container: document.getElementById('lbs-footer'),
          theme: 'light',
        });
      `,
      sidebarOpenedDepth: 2,
    },
    demo: {
      script: [
        {
          name: 'header',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/wemap/wemap-header.js',
        },
        {
          name: 'statistic',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-statistic.js',
        },
      ],
      callback: `
        const header = window.TWeMapHeader.init({
          container: document.getElementById('lbs-header'),
          theme: 'light',
        });
        header.setActiveMenu('服务与支持');
      `,
    },
    news: {
      script: [
        {
          name: 'header',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/wemap/wemap-header.js',
        },
        {
          name: 'footer',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/wemap/wemap-footer.js',
        },
        {
          name: 'statistic',
          src: 'https://mapapi.qq.com/web/lbsComponents/v/lbs-statistic.js',
        },
      ],
      callback: `
        window.TWeMapHeader.init({
          container: document.getElementById('lbs-header'),
          position: 'relative',
        });
        window.TWeMapFooter.init({
          container: document.getElementById('lbs-footer')
        });
      `,
    },
    showFeedback: false,
    appkey: '0WEB0D1Y7K4GAIBB', // 灯塔appkey
  },
];
